export const initSplashSection = (): void => {
  const LOADING_MS = 1000;
  const loader = document.getElementById('splash-section');
  const content = document.getElementById('page-content');
  const sloth = document.querySelector<HTMLImageElement>(
    '.splash-section-sloth',
  );
  const bar = document.querySelector<HTMLElement>('.splash-section-bar');
  const track = document.querySelector<HTMLElement>('.splash-section-track');
  const barFill = document.querySelector<HTMLElement>(
    '.splash-section-bar-fill',
  );

  const updateTravel = (): void => {
    if (!track || !bar || !sloth) return;
    const travel = Math.max(0, bar.clientWidth - sloth.clientWidth);
    track.style.setProperty('--sloth-travel', `${travel}px`);
  };

  const startAnimations = (): void => {
    updateTravel();
    if (loader) loader.style.setProperty('--loading-ms', `${LOADING_MS}ms`);
    loader?.classList.add('splash-section--ready');
  };

  requestAnimationFrame(() => {
    startAnimations();
  });

  window.addEventListener('resize', updateTravel, { passive: true });

  const done = (): void => {
    if (content) content.hidden = false;
    if (loader) loader.remove();
    document.body.classList.remove('is-loading');
    document.body.dataset.loading = 'false';
    window.removeEventListener('resize', updateTravel);
  };

  const fallback = window.setTimeout(done, LOADING_MS + 250);
  barFill?.addEventListener(
    'animationend',
    () => {
      window.clearTimeout(fallback);
      done();
    },
    { once: true },
  );
};
